import {
  BOOKMARK_PROBLEM_LISTS_DEFAULT_MAX_COUNT,
  BOOKMARK_PROBLEM_LISTS_MAX_COUNT,
  BOOKMARK_PROBLEMS_DEFAULT_MAX_COUNT,
  BOOKMARK_PROBLEMS_MAX_COUNT
} from '../resources/config';

export class BookmarkProblemListsUtil {
  static getListsMaxCount(schoolId: string): number {
    const maxCount = BOOKMARK_PROBLEM_LISTS_MAX_COUNT[schoolId];
    if (maxCount) return maxCount;

    return BOOKMARK_PROBLEM_LISTS_DEFAULT_MAX_COUNT;
  }

  static getProblemsMaxCount(schoolId: string): number {
    const maxCount = BOOKMARK_PROBLEMS_MAX_COUNT[schoolId];
    if (maxCount) return maxCount;

    return BOOKMARK_PROBLEMS_DEFAULT_MAX_COUNT;
  }
}
